export const GET_ALL_COUNTER_INSTALLATION_PLACES = "GET_ALL_COUNTER_INSTALLATION_PLACES"
export const CREATE_COUNTER_INSTALLATION_PLACE = "CREATE_COUNTER_INSTALLATION_PLACE"
export const UPDATE_COUNTER_INSTALLATION_PLACE = "UPDATE_COUNTER_INSTALLATION_PLACE"
export const DELETE_COUNTER_INSTALLATION_PLACE = "DELETE_COUNTER_INSTALLATION_PLACE"
export const SELECT_COUNTER_INSTALLATION_PLACE = "SELECT_COUNTER_INSTALLATION_PLACE"
